var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDefaultUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eff0f5",
    d: "M0,0H300V300H0Z",
    id: "path_0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M117.195,150.394A89.012,89.012 0,0 0,61.059 232.989,5.93 5.93,0 0,0 67.011,238.942L233.035,238.942a5.93,5.93 0,0 0,5.906 -5.953,89.016 89.016,0 0,0 -56.121,-82.6 53.061,53.061 0,0 1,-32.82 11.419A52.99,52.99 0,0 1,117.195 150.394Z",
    id: "path_1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M150,61.059a47.424,47.424 0,1 0,47.447 47.4A47.466,47.466 0,0 0,150 61.059Z",
    id: "path_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultUser);
export default __webpack_public_path__ + "static/media/ic_default_user.51b2b87c6c8ad1046f04def6980b5096.svg";
export { ForwardRef as ReactComponent };